module.exports = __webpack_public_path__ + "img/index5.d5379ed6.png";